import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

const { SPACING } = Tokens;

const SPACING_6 = '0.375rem';

export default {
  ReferenceDiv: styled.div`
    position: absolute;
    visibility: hidden;
    width: ${props => props.listMaxWidth};
  `,
  MenuItem: styled.li`
    ${props =>
    css`
        direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
      `}
    list-style-type: none;
    outline: none;
    ${props =>
    css`
        float: ${(props.RTL || props.$rtl || props.rtl) ? 'right' : 'left'};
      `}
    box-sizing: content-box;
    padding: ${SPACING.SPACING_0} ${SPACING_6};
    &:last-child {
      ${props =>
    css`
          padding: ${(props.RTL || props.$rtl || props.rtl) ? `0 ${SPACING_6} 0 0` : `0 0 0 ${SPACING_6}`};
        `}
    }
    &:first-child {
      ${props =>
    css`
          padding: ${(props.RTL || props.$rtl || props.rtl) ? `0 0 0 ${SPACING_6}` : `0 ${SPACING_6} 0 0`};
        `}
    }
  `
};
